import { z } from "zod";

export const schema = z.object({
  id: z.string().optional(),
  label: z.string(),
  description: z.string(),
  position: z.coerce.number(),
  allowInWeb: z.boolean().default(false),
});

export const categorySchema = schema;
